// eslint-disable-next-line no-restricted-imports
import { OrderListItemFragment } from 'api/generated/graphql';
import { OrdersListItemData } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity/order/orderOperationType';
import { OrderStatusType } from 'api/types/entity/order/orderStatusType';

import { parseManagerData } from '../parseManagerData';

import { orderTypeMap } from './parseOrderEntity';

export const parseOrderListItemData = (
  order: OrderListItemFragment
): OrdersListItemData => ({
  id: order.id,
  operationType: OrderOperationType[order.operationType],
  orderType: orderTypeMap[order.operationType],
  number: order.number ?? undefined,
  createdAt: new Date(order.createdAt),
  client: {
    id: order.ownerId,
    fullName: order.ownerFullName ?? undefined,
    type: order.ownerType,
  },
  signedAt: order.signedAt ? new Date(order.signedAt) : undefined,
  status: OrderStatusType[order.status],
  startDate: order.startDate ? new Date(order.startDate) : undefined,
  endDate: order.endDate ? new Date(order.endDate) : undefined,
  closedDate: order.closedDate ? new Date(order.closedDate) : undefined,
  isin: order.financialInstrument.isin.value,
  currency:
    order.transactionVolume?.currency ??
    order.transferVolume?.currency ??
    undefined,
  unitPrice:
    order.transactionVolume?.unitPrice ??
    order.transferVolume?.unitPrice ??
    undefined,
  quantity: order.transactionVolume?.quantity || order.transferVolume?.quantity,
  transactionAmount:
    order.transactionVolume?.transactionAmount ??
    order.transferVolume?.transactionAmount ??
    undefined,
  fmNumber: order.fmNumber ?? undefined,
  employee: order.assignedEmployee
    ? parseManagerData(order.assignedEmployee)
    : undefined,
});
